/**
 * @generated SignedSource<<3fa707f817861eabe44c3fc64165d77f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FilterMenuItemRefactored$data = {
  readonly filterId: string;
  readonly id: string;
  readonly isFavourite: boolean | null;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterActions" | "Nav4FilterActionsRefactored">;
  readonly " $fragmentType": "Nav4FilterMenuItemRefactored";
};
export type Nav4FilterMenuItemRefactored$key = {
  readonly " $data"?: Nav4FilterMenuItemRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterMenuItemRefactored">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4FilterMenuItemRefactored",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "filterId"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4FilterActions"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4FilterActionsRefactored"
    }
  ],
  "type": "JiraFilter",
  "abstractKey": "__isJiraFilter"
};

(node as any).hash = "1a9c987b188f5a1537fae0e4f99f0d9c";

export default node;
